import React, { ReactNode } from 'react';
import dynamic from 'next/dynamic';

const SendCopyButton = dynamic(() => import('./SendCopyButton'));
const BookDemoButton = dynamic(() => import('./BookDemoButton'));
const GetStartedButton = dynamic(() => import('./GetStartedButton'));

type Props = {
  showBookingButton?: boolean;
  showSendFreeCopyButton?: boolean;
  doNotShowGetStartFree?: boolean;
  onClickSendFreeCopyButton?: () => void;
  onBookingButtonClick?: () => void;
  onGetStartedButtonClick?: () => void;
  bookingButtonLabel?: ReactNode;
  disableGetStartedFreeHref?: boolean;
};

export function ActionsButton({
  showBookingButton,
  showSendFreeCopyButton,
  onClickSendFreeCopyButton,
  onBookingButtonClick,
  doNotShowGetStartFree,
  bookingButtonLabel,
  onGetStartedButtonClick,
  disableGetStartedFreeHref,
}: Props) {
  if (showBookingButton) {
    return (
      <BookDemoButton onClick={onBookingButtonClick}>
        {bookingButtonLabel}
      </BookDemoButton>
    );
  }
  if (showSendFreeCopyButton) {
    return <SendCopyButton onClick={onClickSendFreeCopyButton} />;
  }
  if (!doNotShowGetStartFree) {
    return (
      <GetStartedButton
        onClick={onGetStartedButtonClick}
        disableGetStartedFreeHref={disableGetStartedFreeHref}
      />
    );
  }
  return null;
}
